/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { DatasetType } from './DatasetType';
import { DatasetTypeFromJSON, DatasetTypeFromJSONTyped, DatasetTypeToJSON, } from './DatasetType';
import type { ImageType } from './ImageType';
import { ImageTypeFromJSON, ImageTypeFromJSONTyped, ImageTypeToJSON, } from './ImageType';
import type { SharedAccessType } from './SharedAccessType';
import { SharedAccessTypeFromJSON, SharedAccessTypeFromJSONTyped, SharedAccessTypeToJSON, } from './SharedAccessType';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface DatasetData
 *
 */
// create custom validators for the regexes
typia.customValidators.insert("pattern_DatasetData_id")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
typia.customValidators.insert("pattern_DatasetData_name")("string")(() => {
    const regex = new RegExp(/^[a-zA-Z0-9][a-zA-Z0-9 _-]+$/);
    return (value: string) => !!regex.exec(value);
});
typia.customValidators.insert("pattern_DatasetData_metaDataConfigurationId")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
typia.customValidators.insert("pattern_DatasetData_accessRole")("string")(() => {
    const regex = new RegExp(/^0b[01]{6}$/);
    return (value: string) => !!regex.exec(value);
});
typia.customValidators.insert("pattern_DatasetData_parentDatasetId")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
typia.customValidators.insert("pattern_DatasetData_originalDatasetId")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
export interface DatasetData {
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof DatasetData
        
        
    * @pattern_DatasetData_id
         */
    id: string;
    /**
     *
     * #type string
     * #memberof DatasetData
        
        
    * @pattern_DatasetData_name
    * @minLength 3
         */
    name: string;
    /**
     * The owner of the dataset
     * #type string
     * #memberof DatasetData
        
        
         */
    userId: string;
    /**
     *
     * #type SharedAccessType
     * #memberof DatasetData
        
        
         */
    accessType?: SharedAccessType;
    /**
     *
     * #type DatasetType
     * #memberof DatasetData
        
        
         */
    type: DatasetType;
    /**
     *
     * #type ImageType
     * #memberof DatasetData
        
        
         */
    imgType?: ImageType;
    /**
     *
     * #type number
     * #memberof DatasetData
        * @type int
        
         */
    nSamples: number;
    /**
     *
     * #type number
     * #memberof DatasetData
        
        
         */
    sizeInBytes: number;
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof DatasetData
        
        
    * @pattern_DatasetData_metaDataConfigurationId
         */
    metaDataConfigurationId?: string;
    /**
     *
     * #type Array<string>
     * #memberof DatasetData
        
        
         */
    datasources?: Array<string>;
    /**
     * unix timestamp in milliseconds
     * #type number
     * #memberof DatasetData
        
    * @minimum 0
            
         */
    createdAt: number;
    /**
     * unix timestamp in milliseconds
     * #type number
     * #memberof DatasetData
        
    * @minimum 0
            
         */
    lastModifiedAt: number;
    /**
     * unix timestamp in seconds
     * #type number
     * #memberof DatasetData
        * @type int
    * @minimum 0
            
         */
    datasourceProcessedUntilTimestamp?: number;
    /**
     * AccessRole bitmask of the one accessing the dataset
     * #type string
     * #memberof DatasetData
        
        
    * @pattern_DatasetData_accessRole
         */
    accessRole?: string;
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof DatasetData
        
        
    * @pattern_DatasetData_parentDatasetId
         */
    parentDatasetId?: string;
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof DatasetData
        
        
    * @pattern_DatasetData_originalDatasetId
         */
    originalDatasetId?: string;
}
/**
 * Check if a given object implements the DatasetData interface.
 */
export function instanceOfDatasetData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "nSamples" in value;
    isInstance = isInstance && "sizeInBytes" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "lastModifiedAt" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { DatasetTypeValidator, DatasetTypeStringifyShape, DatasetTypeStringifyShapeProperties, } from './DatasetType';
import { ImageTypeValidator, ImageTypeStringifyShape, ImageTypeStringifyShapeProperties, } from './ImageType';
import { SharedAccessTypeValidator, SharedAccessTypeStringifyShape, SharedAccessTypeStringifyShapeProperties, } from './SharedAccessType';
export const DatasetDataTypiaAssertEquals = (input: any) => {
    return ((input: any): DatasetData => {
        const __is = (input: any, _exceptionable: boolean = true): input is DatasetData => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.id && $is_custom("pattern_DatasetData_id", "string", "", input.id) && ("string" === typeof input.name && 3 <= input.name.length && $is_custom("pattern_DatasetData_name", "string", "", input.name)) && "string" === typeof input.userId && (undefined === input.accessType || "WRITE" === input.accessType) && ("Crops" === input.type || "Images" === input.type || "Videos" === input.type) && (undefined === input.imgType || "full" === input.imgType || "thumbnail" === input.imgType || "meta" === input.imgType) && ("number" === typeof input.nSamples && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647)) && "number" === typeof input.sizeInBytes && (undefined === input.metaDataConfigurationId || "string" === typeof input.metaDataConfigurationId && $is_custom("pattern_DatasetData_metaDataConfigurationId", "string", "", input.metaDataConfigurationId)) && (undefined === input.datasources || Array.isArray(input.datasources) && input.datasources.every((elem: any, _index1: number) => "string" === typeof elem)) && ("number" === typeof input.createdAt && 0 <= input.createdAt) && ("number" === typeof input.lastModifiedAt && 0 <= input.lastModifiedAt) && (undefined === input.datasourceProcessedUntilTimestamp || "number" === typeof input.datasourceProcessedUntilTimestamp && Math.floor(input.datasourceProcessedUntilTimestamp) === input.datasourceProcessedUntilTimestamp && (-2147483648 <= input.datasourceProcessedUntilTimestamp && input.datasourceProcessedUntilTimestamp <= 2147483647) && 0 <= input.datasourceProcessedUntilTimestamp) && (undefined === input.accessRole || "string" === typeof input.accessRole && $is_custom("pattern_DatasetData_accessRole", "string", "", input.accessRole)) && (undefined === input.parentDatasetId || "string" === typeof input.parentDatasetId && $is_custom("pattern_DatasetData_parentDatasetId", "string", "", input.parentDatasetId)) && (undefined === input.originalDatasetId || "string" === typeof input.originalDatasetId && $is_custom("pattern_DatasetData_originalDatasetId", "string", "", input.originalDatasetId)) && (8 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["id", "name", "userId", "accessType", "type", "imgType", "nSamples", "sizeInBytes", "metaDataConfigurationId", "datasources", "createdAt", "lastModifiedAt", "datasourceProcessedUntilTimestamp", "accessRole", "parentDatasetId", "originalDatasetId"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DatasetData => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_DatasetData_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasetData_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("string" === typeof input.name && (3 <= input.name.length || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@minLength 3)",
                    value: input.name
                })) && ($is_custom("pattern_DatasetData_name", "string", "", input.name) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@pattern_DatasetData_name)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && ("string" === typeof input.userId || $guard(_exceptionable, {
                    path: _path + ".userId",
                    expected: "string",
                    value: input.userId
                })) && (undefined === input.accessType || "WRITE" === input.accessType || $guard(_exceptionable, {
                    path: _path + ".accessType",
                    expected: "(\"WRITE\" | undefined)",
                    value: input.accessType
                })) && ("Crops" === input.type || "Images" === input.type || "Videos" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"Crops\" | \"Images\" | \"Videos\")",
                    value: input.type
                })) && (undefined === input.imgType || "full" === input.imgType || "thumbnail" === input.imgType || "meta" === input.imgType || $guard(_exceptionable, {
                    path: _path + ".imgType",
                    expected: "(\"full\" | \"meta\" | \"thumbnail\" | undefined)",
                    value: input.imgType
                })) && ("number" === typeof input.nSamples && (Math.floor(input.nSamples) === input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number",
                    value: input.nSamples
                })) && ("number" === typeof input.sizeInBytes || $guard(_exceptionable, {
                    path: _path + ".sizeInBytes",
                    expected: "number",
                    value: input.sizeInBytes
                })) && (undefined === input.metaDataConfigurationId || "string" === typeof input.metaDataConfigurationId && ($is_custom("pattern_DatasetData_metaDataConfigurationId", "string", "", input.metaDataConfigurationId) || $guard(_exceptionable, {
                    path: _path + ".metaDataConfigurationId",
                    expected: "string (@pattern_DatasetData_metaDataConfigurationId)",
                    value: input.metaDataConfigurationId
                })) || $guard(_exceptionable, {
                    path: _path + ".metaDataConfigurationId",
                    expected: "(string | undefined)",
                    value: input.metaDataConfigurationId
                })) && (undefined === input.datasources || (Array.isArray(input.datasources) || $guard(_exceptionable, {
                    path: _path + ".datasources",
                    expected: "(Array<string> | undefined)",
                    value: input.datasources
                })) && input.datasources.every((elem: any, _index1: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".datasources[" + _index1 + "]",
                    expected: "string",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".datasources",
                    expected: "(Array<string> | undefined)",
                    value: input.datasources
                })) && ("number" === typeof input.createdAt && (0 <= input.createdAt || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number (@minimum 0)",
                    value: input.createdAt
                })) || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number",
                    value: input.createdAt
                })) && ("number" === typeof input.lastModifiedAt && (0 <= input.lastModifiedAt || $guard(_exceptionable, {
                    path: _path + ".lastModifiedAt",
                    expected: "number (@minimum 0)",
                    value: input.lastModifiedAt
                })) || $guard(_exceptionable, {
                    path: _path + ".lastModifiedAt",
                    expected: "number",
                    value: input.lastModifiedAt
                })) && (undefined === input.datasourceProcessedUntilTimestamp || "number" === typeof input.datasourceProcessedUntilTimestamp && (Math.floor(input.datasourceProcessedUntilTimestamp) === input.datasourceProcessedUntilTimestamp || $guard(_exceptionable, {
                    path: _path + ".datasourceProcessedUntilTimestamp",
                    expected: "number (@type int)",
                    value: input.datasourceProcessedUntilTimestamp
                })) && (-2147483648 <= input.datasourceProcessedUntilTimestamp && input.datasourceProcessedUntilTimestamp <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".datasourceProcessedUntilTimestamp",
                    expected: "number (@type int)",
                    value: input.datasourceProcessedUntilTimestamp
                })) && (0 <= input.datasourceProcessedUntilTimestamp || $guard(_exceptionable, {
                    path: _path + ".datasourceProcessedUntilTimestamp",
                    expected: "number (@minimum 0)",
                    value: input.datasourceProcessedUntilTimestamp
                })) || $guard(_exceptionable, {
                    path: _path + ".datasourceProcessedUntilTimestamp",
                    expected: "(number | undefined)",
                    value: input.datasourceProcessedUntilTimestamp
                })) && (undefined === input.accessRole || "string" === typeof input.accessRole && ($is_custom("pattern_DatasetData_accessRole", "string", "", input.accessRole) || $guard(_exceptionable, {
                    path: _path + ".accessRole",
                    expected: "string (@pattern_DatasetData_accessRole)",
                    value: input.accessRole
                })) || $guard(_exceptionable, {
                    path: _path + ".accessRole",
                    expected: "(string | undefined)",
                    value: input.accessRole
                })) && (undefined === input.parentDatasetId || "string" === typeof input.parentDatasetId && ($is_custom("pattern_DatasetData_parentDatasetId", "string", "", input.parentDatasetId) || $guard(_exceptionable, {
                    path: _path + ".parentDatasetId",
                    expected: "string (@pattern_DatasetData_parentDatasetId)",
                    value: input.parentDatasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".parentDatasetId",
                    expected: "(string | undefined)",
                    value: input.parentDatasetId
                })) && (undefined === input.originalDatasetId || "string" === typeof input.originalDatasetId && ($is_custom("pattern_DatasetData_originalDatasetId", "string", "", input.originalDatasetId) || $guard(_exceptionable, {
                    path: _path + ".originalDatasetId",
                    expected: "string (@pattern_DatasetData_originalDatasetId)",
                    value: input.originalDatasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".originalDatasetId",
                    expected: "(string | undefined)",
                    value: input.originalDatasetId
                })) && (8 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["id", "name", "userId", "accessType", "type", "imgType", "nSamples", "sizeInBytes", "metaDataConfigurationId", "datasources", "createdAt", "lastModifiedAt", "datasourceProcessedUntilTimestamp", "accessRole", "parentDatasetId", "originalDatasetId"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasetData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasetData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DatasetDataTypiaAssertStringify = (input: DatasetData): string => {
    return ((input: any): string => { const assert = (input: any): DatasetData => {
        const __is = (input: any): input is DatasetData => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $io0 = (input: any): boolean => "string" === typeof input.id && $is_custom("pattern_DatasetData_id", "string", "", input.id) && ("string" === typeof input.name && 3 <= input.name.length && $is_custom("pattern_DatasetData_name", "string", "", input.name)) && "string" === typeof input.userId && (undefined === input.accessType || "WRITE" === input.accessType) && ("Crops" === input.type || "Images" === input.type || "Videos" === input.type) && (undefined === input.imgType || "full" === input.imgType || "thumbnail" === input.imgType || "meta" === input.imgType) && ("number" === typeof input.nSamples && !Number.isNaN(input.nSamples) && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647)) && ("number" === typeof input.sizeInBytes && !Number.isNaN(input.sizeInBytes)) && (undefined === input.metaDataConfigurationId || "string" === typeof input.metaDataConfigurationId && $is_custom("pattern_DatasetData_metaDataConfigurationId", "string", "", input.metaDataConfigurationId)) && (undefined === input.datasources || Array.isArray(input.datasources) && input.datasources.every((elem: any) => "string" === typeof elem)) && ("number" === typeof input.createdAt && !Number.isNaN(input.createdAt) && 0 <= input.createdAt) && ("number" === typeof input.lastModifiedAt && !Number.isNaN(input.lastModifiedAt) && 0 <= input.lastModifiedAt) && (undefined === input.datasourceProcessedUntilTimestamp || "number" === typeof input.datasourceProcessedUntilTimestamp && !Number.isNaN(input.datasourceProcessedUntilTimestamp) && Math.floor(input.datasourceProcessedUntilTimestamp) === input.datasourceProcessedUntilTimestamp && (-2147483648 <= input.datasourceProcessedUntilTimestamp && input.datasourceProcessedUntilTimestamp <= 2147483647) && 0 <= input.datasourceProcessedUntilTimestamp) && (undefined === input.accessRole || "string" === typeof input.accessRole && $is_custom("pattern_DatasetData_accessRole", "string", "", input.accessRole)) && (undefined === input.parentDatasetId || "string" === typeof input.parentDatasetId && $is_custom("pattern_DatasetData_parentDatasetId", "string", "", input.parentDatasetId)) && (undefined === input.originalDatasetId || "string" === typeof input.originalDatasetId && $is_custom("pattern_DatasetData_originalDatasetId", "string", "", input.originalDatasetId));
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DatasetData => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_DatasetData_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasetData_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("string" === typeof input.name && (3 <= input.name.length || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@minLength 3)",
                    value: input.name
                })) && ($is_custom("pattern_DatasetData_name", "string", "", input.name) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@pattern_DatasetData_name)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && ("string" === typeof input.userId || $guard(_exceptionable, {
                    path: _path + ".userId",
                    expected: "string",
                    value: input.userId
                })) && (undefined === input.accessType || "WRITE" === input.accessType || $guard(_exceptionable, {
                    path: _path + ".accessType",
                    expected: "(\"WRITE\" | undefined)",
                    value: input.accessType
                })) && ("Crops" === input.type || "Images" === input.type || "Videos" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"Crops\" | \"Images\" | \"Videos\")",
                    value: input.type
                })) && (undefined === input.imgType || "full" === input.imgType || "thumbnail" === input.imgType || "meta" === input.imgType || $guard(_exceptionable, {
                    path: _path + ".imgType",
                    expected: "(\"full\" | \"meta\" | \"thumbnail\" | undefined)",
                    value: input.imgType
                })) && ("number" === typeof input.nSamples && !Number.isNaN(input.nSamples) && (Math.floor(input.nSamples) === input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number",
                    value: input.nSamples
                })) && ("number" === typeof input.sizeInBytes && !Number.isNaN(input.sizeInBytes) || $guard(_exceptionable, {
                    path: _path + ".sizeInBytes",
                    expected: "number",
                    value: input.sizeInBytes
                })) && (undefined === input.metaDataConfigurationId || "string" === typeof input.metaDataConfigurationId && ($is_custom("pattern_DatasetData_metaDataConfigurationId", "string", "", input.metaDataConfigurationId) || $guard(_exceptionable, {
                    path: _path + ".metaDataConfigurationId",
                    expected: "string (@pattern_DatasetData_metaDataConfigurationId)",
                    value: input.metaDataConfigurationId
                })) || $guard(_exceptionable, {
                    path: _path + ".metaDataConfigurationId",
                    expected: "(string | undefined)",
                    value: input.metaDataConfigurationId
                })) && (undefined === input.datasources || (Array.isArray(input.datasources) || $guard(_exceptionable, {
                    path: _path + ".datasources",
                    expected: "(Array<string> | undefined)",
                    value: input.datasources
                })) && input.datasources.every((elem: any, _index1: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".datasources[" + _index1 + "]",
                    expected: "string",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".datasources",
                    expected: "(Array<string> | undefined)",
                    value: input.datasources
                })) && ("number" === typeof input.createdAt && !Number.isNaN(input.createdAt) && (0 <= input.createdAt || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number (@minimum 0)",
                    value: input.createdAt
                })) || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number",
                    value: input.createdAt
                })) && ("number" === typeof input.lastModifiedAt && !Number.isNaN(input.lastModifiedAt) && (0 <= input.lastModifiedAt || $guard(_exceptionable, {
                    path: _path + ".lastModifiedAt",
                    expected: "number (@minimum 0)",
                    value: input.lastModifiedAt
                })) || $guard(_exceptionable, {
                    path: _path + ".lastModifiedAt",
                    expected: "number",
                    value: input.lastModifiedAt
                })) && (undefined === input.datasourceProcessedUntilTimestamp || "number" === typeof input.datasourceProcessedUntilTimestamp && !Number.isNaN(input.datasourceProcessedUntilTimestamp) && (Math.floor(input.datasourceProcessedUntilTimestamp) === input.datasourceProcessedUntilTimestamp || $guard(_exceptionable, {
                    path: _path + ".datasourceProcessedUntilTimestamp",
                    expected: "number (@type int)",
                    value: input.datasourceProcessedUntilTimestamp
                })) && (-2147483648 <= input.datasourceProcessedUntilTimestamp && input.datasourceProcessedUntilTimestamp <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".datasourceProcessedUntilTimestamp",
                    expected: "number (@type int)",
                    value: input.datasourceProcessedUntilTimestamp
                })) && (0 <= input.datasourceProcessedUntilTimestamp || $guard(_exceptionable, {
                    path: _path + ".datasourceProcessedUntilTimestamp",
                    expected: "number (@minimum 0)",
                    value: input.datasourceProcessedUntilTimestamp
                })) || $guard(_exceptionable, {
                    path: _path + ".datasourceProcessedUntilTimestamp",
                    expected: "(number | undefined)",
                    value: input.datasourceProcessedUntilTimestamp
                })) && (undefined === input.accessRole || "string" === typeof input.accessRole && ($is_custom("pattern_DatasetData_accessRole", "string", "", input.accessRole) || $guard(_exceptionable, {
                    path: _path + ".accessRole",
                    expected: "string (@pattern_DatasetData_accessRole)",
                    value: input.accessRole
                })) || $guard(_exceptionable, {
                    path: _path + ".accessRole",
                    expected: "(string | undefined)",
                    value: input.accessRole
                })) && (undefined === input.parentDatasetId || "string" === typeof input.parentDatasetId && ($is_custom("pattern_DatasetData_parentDatasetId", "string", "", input.parentDatasetId) || $guard(_exceptionable, {
                    path: _path + ".parentDatasetId",
                    expected: "string (@pattern_DatasetData_parentDatasetId)",
                    value: input.parentDatasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".parentDatasetId",
                    expected: "(string | undefined)",
                    value: input.parentDatasetId
                })) && (undefined === input.originalDatasetId || "string" === typeof input.originalDatasetId && ($is_custom("pattern_DatasetData_originalDatasetId", "string", "", input.originalDatasetId) || $guard(_exceptionable, {
                    path: _path + ".originalDatasetId",
                    expected: "string (@pattern_DatasetData_originalDatasetId)",
                    value: input.originalDatasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".originalDatasetId",
                    expected: "(string | undefined)",
                    value: input.originalDatasetId
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasetData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasetData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DatasetData): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${undefined === input.accessType ? "" : `"accessType":${undefined !== input.accessType ? (() => {
            if ("string" === typeof input.accessType)
                return $string(input.accessType);
            if ("string" === typeof input.accessType)
                return "\"" + input.accessType + "\"";
            $throws({
                expected: "(\"WRITE\" | undefined)",
                value: input.accessType
            });
        })() : undefined},`}${undefined === input.imgType ? "" : `"imgType":${undefined !== input.imgType ? (() => {
            if ("string" === typeof input.imgType)
                return $string(input.imgType);
            if ("string" === typeof input.imgType)
                return "\"" + input.imgType + "\"";
            $throws({
                expected: "(\"full\" | \"meta\" | \"thumbnail\" | undefined)",
                value: input.imgType
            });
        })() : undefined},`}${undefined === input.metaDataConfigurationId ? "" : `"metaDataConfigurationId":${undefined !== input.metaDataConfigurationId ? $string(input.metaDataConfigurationId) : undefined},`}${undefined === input.datasources ? "" : `"datasources":${undefined !== input.datasources ? `[${input.datasources.map((elem: any) => $string(elem)).join(",")}]` : undefined},`}${undefined === input.datasourceProcessedUntilTimestamp ? "" : `"datasourceProcessedUntilTimestamp":${undefined !== input.datasourceProcessedUntilTimestamp ? input.datasourceProcessedUntilTimestamp : undefined},`}${undefined === input.accessRole ? "" : `"accessRole":${undefined !== input.accessRole ? $string(input.accessRole) : undefined},`}${undefined === input.parentDatasetId ? "" : `"parentDatasetId":${undefined !== input.parentDatasetId ? $string(input.parentDatasetId) : undefined},`}${undefined === input.originalDatasetId ? "" : `"originalDatasetId":${undefined !== input.originalDatasetId ? $string(input.originalDatasetId) : undefined},`}"id":${$string(input.id)},"name":${$string(input.name)},"userId":${$string(input.userId)},"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"Crops\" | \"Images\" | \"Videos\")",
                value: input.type
            });
        })()},"nSamples":${input.nSamples},"sizeInBytes":${input.sizeInBytes},"createdAt":${input.createdAt},"lastModifiedAt":${input.lastModifiedAt}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const DatasetDataValidatorShape = {
    'id': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'name': yup.string().matches(/^[a-zA-Z0-9][a-zA-Z0-9 _-]+$/).min(3).defined(),
    'userId': yup.string().defined(),
    'accessType': SharedAccessTypeValidator.optional().default(undefined),
    'type': DatasetTypeValidator.defined(),
    'imgType': ImageTypeValidator.optional().default(undefined),
    'nSamples': yup.number().integer().defined(),
    'sizeInBytes': yup.number().defined(),
    'metaDataConfigurationId': yup.string().matches(/^[a-f0-9]{24}$/),
    'datasources': yup.array().of(yup.string()),
    'createdAt': yup.number().min(0).defined(),
    'lastModifiedAt': yup.number().min(0).defined(),
    'datasourceProcessedUntilTimestamp': yup.number().integer().min(0),
    'accessRole': yup.string().matches(/^0b[01]{6}$/),
    'parentDatasetId': yup.string().matches(/^[a-f0-9]{24}$/),
    'originalDatasetId': yup.string().matches(/^[a-f0-9]{24}$/),
};
export const DatasetDataValidator = yup.object().shape(DatasetDataValidatorShape);
export const DatasetDataStringifyShapeProperties: ObjectSchema['properties'] = {
    'id': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'name': {
        'type': 'string',
        'pattern': "/^[a-zA-Z0-9][a-zA-Z0-9 _-]+$/".slice(1, -1),
        'minLength': 3,
    } as unknown as fastJSON.StringSchema,
    'userId': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'accessType': SharedAccessTypeStringifyShape,
    'type': DatasetTypeStringifyShape,
    'imgType': ImageTypeStringifyShape,
    'nSamples': {
        'type': 'integer',
    } as unknown as fastJSON.IntegerSchema,
    'sizeInBytes': {
        'type': 'number',
    } as unknown as fastJSON.NumberSchema,
    'metaDataConfigurationId': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'datasources': {
        type: 'array',
        items: {
            type: 'string'
        } as unknown as fastJSON.Schema,
    } as unknown as fastJSON.ArraySchema,
    'createdAt': {
        'type': 'number',
        'minimum': 0,
    } as unknown as fastJSON.NumberSchema,
    'lastModifiedAt': {
        'type': 'number',
        'minimum': 0,
    } as unknown as fastJSON.NumberSchema,
    'datasourceProcessedUntilTimestamp': {
        'type': 'integer',
        'minimum': 0,
    } as unknown as fastJSON.IntegerSchema,
    'accessRole': {
        'type': 'string',
        'pattern': "/^0b[01]{6}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'parentDatasetId': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'originalDatasetId': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
};
export const DatasetDataStringifyShape: ObjectSchema = {
    title: 'DatasetData Stringifier',
    type: 'object',
    properties: {
        ...DatasetDataStringifyShapeProperties
    },
    required: [
        'id',
        'name',
        'userId',
        'type',
        'nSamples',
        'sizeInBytes',
        'createdAt',
        'lastModifiedAt',
    ],
};
export const DatasetDataStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DatasetDataStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DatasetDataStringify: (data: DatasetData) => string = DatasetDataStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DatasetDataFromJSON(json: any): DatasetData {
    return DatasetDataFromJSONTyped(json, false);
}
export function DatasetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'id': json['id'],
        'name': json['name'],
        'userId': json['userId'],
        'accessType': !exists(json, 'accessType') ? undefined : SharedAccessTypeFromJSON(json['accessType']),
        'type': DatasetTypeFromJSON(json['type']),
        'imgType': !exists(json, 'imgType') ? undefined : ImageTypeFromJSON(json['imgType']),
        'nSamples': json['nSamples'],
        'sizeInBytes': json['sizeInBytes'],
        'metaDataConfigurationId': !exists(json, 'metaDataConfigurationId') ? undefined : json['metaDataConfigurationId'],
        'datasources': !exists(json, 'datasources') ? undefined : json['datasources'],
        'createdAt': json['createdAt'],
        'lastModifiedAt': json['lastModifiedAt'],
        'datasourceProcessedUntilTimestamp': !exists(json, 'datasourceProcessedUntilTimestamp') ? undefined : json['datasourceProcessedUntilTimestamp'],
        'accessRole': !exists(json, 'accessRole') ? undefined : json['accessRole'],
        'parentDatasetId': !exists(json, 'parentDatasetId') ? undefined : json['parentDatasetId'],
        'originalDatasetId': !exists(json, 'originalDatasetId') ? undefined : json['originalDatasetId'],
    };
}
export function DatasetDataToJSON(value?: DatasetData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'userId': value.userId,
        'accessType': SharedAccessTypeToJSON(value.accessType),
        'type': DatasetTypeToJSON(value.type),
        'imgType': ImageTypeToJSON(value.imgType),
        'nSamples': value.nSamples,
        'sizeInBytes': value.sizeInBytes,
        'metaDataConfigurationId': value.metaDataConfigurationId,
        'datasources': value.datasources,
        'createdAt': value.createdAt,
        'lastModifiedAt': value.lastModifiedAt,
        'datasourceProcessedUntilTimestamp': value.datasourceProcessedUntilTimestamp,
        'accessRole': value.accessRole,
        'parentDatasetId': value.parentDatasetId,
        'originalDatasetId': value.originalDatasetId,
    };
}
